module.exports = __webpack_public_path__ + "static/img/NSWSwifts.b0be29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSWSwifts.png
// module id = nFgS
// module chunks = 1